module.exports = __webpack_public_path__ + "img/globe-stand.85762432.svg";